import React, { Component } from 'react';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { $ } from 'rype-bootstrap';
import './style.css';

const calculateStartsIn = (now, startTime) => {
  const diff = startTime.diff(now);
  const diffDuration = moment.duration(diff);
  const days = diffDuration.days();
  const hours = diffDuration.hours();
  const minutes = diffDuration.minutes();
  const startsIn = minutes > 9 ? `${hours}h ${minutes}m` : `${hours}h 0${minutes}m`;
  return days > 0 ? `${days}d ${startsIn}` : startsIn;
};

class TeacherReservation extends Component {
  constructor() {
    super();
    $.noConflict();

    this.state = {
      marginLeft: 0,
      marginTop: 0
    };
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps) {
    if (this.props.active === true && prevProps.active !== this.props.active) {
      this.handleResize();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const timeElId = `#teacher-reservation__time-${this.props.reservation.id}`;
    const timeEl = $(timeElId);
    const nameElId = `#teacher-reservation__name-${this.props.reservation.id}`;
    const nameEl = $(nameElId);
    if (timeEl.length && nameEl.length) {
      if (nameEl[0].offsetLeft < 100) {
        this.setState({ marginLeft: 0, paddingTop: 140 });
      } else {
        this.setState({ marginLeft: timeEl[0].offsetWidth, paddingTop: 0 });
      }
    }
  }

  handleDetails = () => {
    const { reservation, onDetails } = this.props;
    onDetails(reservation);
  }

  handleReschedule = (event) => {
    event.preventDefault();

    const { reservation, onReschedule } = this.props;
    onReschedule(reservation);
  }

  handleCancel = (event) => {
    event.preventDefault();

    const { reservation, onCancel } = this.props;
    onCancel(reservation);
  }

  render() {
    const {
      active, now, reservation, source
    } = this.props;
    const startTime = moment(reservation.startTime);
    const endTime = startTime.clone().add(reservation.duration, 'minutes');

    let personalNote = reservation.customerMessage;
    if (isEmpty(personalNote)) {
      personalNote = 'N/A';
    }

    return (
      <div className="teacher-reservation px-5 py-4 mb-4">
        <p className="teacher-reservation__service mb-2">{reservation.service.description}</p>
        <div className="d-flex">
          <div style={{ flex: 1 }}>
            <div className="row">
              <div
                id={`teacher-reservation__time-${reservation.id}`}
                className={classnames(
                  {
                    'col-12 col-xl-7 col-lg-12 col-md-7 col-sm-12': source === 'home'
                  },
                  {
                    'col-12 col-md-7 col-sm-7': source === 'schedule'
                  }
                )}
              >
                <h5 className="teacher-reservation__time-text">{`${startTime.format(
                  'h:mma'
                )} - ${endTime.format('h:mma')}`}
                </h5>
                <p className="teacher-reservation__starts-in mb-4">
                  Starts in <strong>{calculateStartsIn(now, startTime)}</strong>
                </p>
              </div>
              <div
                id={`teacher-reservation__name-${reservation.id}`}
                className={classnames(
                  { 'col-12 col-xl-5 col-lg-12 col-md-5 col-sm-12': source === 'home' },
                  { 'col-12 col-md-5 col-sm-5': source === 'schedule' }
                )}
              >
                <h5 className="teacher-reservation__name">{reservation.student.name}</h5>
                <p className="teacher-reservation__customer mb-4">{`Skype: ${
                  reservation.student.skypeName
                }`}
                </p>
              </div>
            </div>
          </div>
          <div>
            <button
              type="button"
              className={classnames('teacher-reservation__btn btn btn-link btn-cursor', {
                active
              })}
              onClick={this.handleDetails}
            >
              {active ? 'Close' : 'Details'}
            </button>
          </div>
        </div>
        {active && (
          <div className="teacher-reservation__details">
            <div className="teacher-reservation__details-action">
              <a
                className="teacher-reservation__details-action-item d-block"
                href="#"
                onClick={this.handleReschedule}
              >
                Reschedule
              </a>
              <a
                className="teacher-reservation__details-action-item d-block"
                href="#"
                onClick={this.handleCancel}
              >
                Cancel
              </a>
            </div>
            <div
              style={{ marginLeft: this.state.marginLeft, paddingTop: this.state.paddingTop }}
              className="teacher-reservation__details-text"
            >
              <h6 className="teacher-reservation__details-text-title">Email</h6>
              <p className="teacher-reservation__details-text-desc mb-4">
                {reservation.student.email}
              </p>
              <h6 className="teacher-reservation__details-text-title">Personal note</h6>
              <p className="teacher-reservation__details-text-desc mb-0">{personalNote}</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default TeacherReservation;



// WEBPACK FOOTER //
// ./src/components/TeacherReservation/index.js